import ChatMessages from "./components/chat-messages";
import ChatRecorder from "./components/chat-recorder";
import ChatPicturePaster from "./components/chat-picture-paster";
import ChatAvatar from "./components/chat-avatar";
import ConversationList from "./components/conversation-list";
import ContactList from "./components/contact-list";
import GroupList from "./components/group-list";
import ChatTitle from "./components/chat-title";
import ChatHistory from "./components/chat-history";
import DetailContact from "./components/detail-contact";
import DetailGroup from "./components/detail-group";
import ChatEmojiPicker from "./components/chat-emoji-picker";
import ChatImageViewer from "./components/chat-image-viewer";
import ChatVideoViewer from "./components/chat-video-viewer.vue";
import Contacts from "./components/contacts";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import {
	getConversations,
	getContacts,
	getGroups,
	getMessages,
	getSignature,
	resetUnreadCountAndReportReadTime,
	recallMessage,
	postTranslatedMessage,
	getGeneralizations,
} from "@/services/api-v2/api-v2";
import GeneralizationList from "./components/generalization-list";
import { updateArray, updateOrCreate, isImageFile, isVideoFile, saveLastOpenPath, getLastOpenPath } from "@/utils/object";
import { upload, uploadVideo } from "@/services/oss/oss";
import { browserNotification, generatePreMessage, sendMessageRequest, sendGeneralizationMessageRequest } from "./message";
import { getCurrentUtcDatetime } from "@/utils/date";
import { debounce } from "lodash";

export const TAB_HEIGHT_OFFSET = 310;

export const MESSAGE_HEIGHT_OFFSET = 400;

export const MESSAGE_TYPE = {
	Text: 0,
	Voice: 1,
	Image: 2,
	Order: 3,
	Check: 4,
	Redirect: 5,
	Markdown: 7,
	Video: 8,
	MerchantOrder: 9,
	Replenishment: 10,
	GroupQuit: 11, // 退出群聊/群成员变动通知
};

export const Send_Method_TYPE = {
	CtrlEnter: "ctrl",
	Enter: "enter",
};

const Media_File_Type = {
	VOICE: "voice",
	IMAGE: "image",
	VIDEO: "video",
};

const Media_File_Type_Config = {
	[Media_File_Type.VOICE]: {
		type: 1,
		fileType: "voice",
		contentType: "audio/aac",
	},
	[Media_File_Type.IMAGE]: {
		type: 2,
		fileType: "picture",
		contentType: "image/jpeg",
	},
	[Media_File_Type.VIDEO]: {
		type: 8,
		fileType: "video",
		contentType: "video/mp4",
	},
};

export default {
	components: {
		ChatMessages,
		ChatRecorder,
		ChatPicturePaster,
		ChatAvatar,
		ConversationList,
		ContactList,
		GroupList,
		ChatTitle,
		ChatHistory,
		DetailContact,
		DetailGroup,
		ChatEmojiPicker,
		ChatImageViewer,
		ChatVideoViewer,
		Contacts,
		GeneralizationList,
	},

	name: "chat",

	created: function () {
		// 因为页面刷新后,正在上传的请求已经中断了，所以需要将所有上传中的消息标记为失败
		const navigation = window.performance.getEntriesByType("navigation")[0];
		if (navigation && navigation.type === "reload") {
			// 只有刷新时才标记失败
			this.$store.commit("uploadingMessages/MARK_ALL_AS_FAILED");
		}

		this.initData();
		this.unsubscribe = this.$store.subscribe((mutation, state) => {
			if (mutation.type == "SOCKET_ONMESSAGE" && state.socket.message) {
				switch (state.socket.message.event) {
					case "messageReceived":
						this.handleOnMessageReceived(state.socket.message.data);
						break;
					case "messageRecalled":
						this.handleOnMessageRecalled(state.socket.message.data);
						break;
					case "conversationUpdated":
						this.handleOnConversationUpdated(state.socket.message.data);
						break;
					case "contactsUpdated":
						this.handleOnContactsUpdated(state.socket.message.data);
						break;
				}
			}
			this.handleWebSocketState(mutation.type);
			this.handleWebSocketState(mutation.type);
		});
	},

	beforeDestroy: function () {
		this.unsubscribe();

		// 清理事件监听器
		document.removeEventListener("mousemove", this.handleResize);
		document.removeEventListener("mouseup", this.stopResize);
	},

	data() {
		return {
			// 对话
			conversations: [],

			// 联系人
			contacts: [],

			// 群聊
			groups: [],

			// 当前对话
			conversation: null,

			// 当前消息
			messages: [],

			// 文本输入框
			content: "",

			// 文本框初始高度
			contentInitHeight: 0,

			// websocket取消监听方法
			unsubscribe: () => {},

			// loading状态
			loading: false,

			tabHeight: window.innerHeight - TAB_HEIGHT_OFFSET,

			messageHeight: window.innerHeight - MESSAGE_HEIGHT_OFFSET,
			generalizationHeight: window.innerHeight - GENERALIZATION_HEIGHT_OFFSET,
			// 定时器
			timer: null,

			// 搜索内容
			searchKeyword: "",

			isSearchFocused: false,

			languageOptions: [
				{
					value: "en",
					label: "English",
				},
				{
					value: "ja",
					label: "Japan",
				},
				{
					value: "ko",
					label: "Korean",
				},
				{
					value: "es",
					label: "Spain",
				},
				{
					value: "th",
					label: "Thai",
				},
				{
					value: "hi",
					label: "Hindi",
				},
				{
					value: "vi",
					label: "Vietnamese",
				},
			],
			languageValue: "",

			// 翻译文本
			translatedContent: "",

			translatedContentHeight: "",
			// 推荐列表
			generalizations: [],
			// 推广详情弹窗是否可见
			generalizationDetailDialogVisible: false,
			sendDialogVisible: false,
			readyToSendGeneralization: {},
			leftWidth: 380, // 初始侧边栏宽度
			isResizing: false,
			startX: 0,
			startWidth: 0,
			minWidth: 280, // 最小宽度
			maxWidth: 600, // 最大宽度

			Send_Method_TYPE,
			sendConfigPopoverVisible: false, // 发送配置弹窗
			sendMethodConfig: Send_Method_TYPE.CtrlEnter, // 发送方式配置: 'ctrl' 表示 Ctrl+Enter 发送, 'enter' 表示 Enter 发送
		};
	},

	destroyed: function () {
		//
	},
	mounted() {
		// 从 localStorage 读取用户的发送配置
		this.loadSendConfig();
	},

	methods: {
		// 初始化数据
		async initData() {
			try {
				this.loading = true;

				const { data: conversations } = await getConversations();

				this.conversations = conversations;

				const { data: contacts } = await getContacts();

				this.contacts = contacts;

				const { data: groups } = await getGroups();

				this.groups = groups;
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 对话列表点击事件
		async handleConversationListClick(conversation) {
			this.conversation = conversation;
			this.isSearchFocused = false;
			this.translatedContent = "";
			this.$nextTick().then(() => {
				this.contentInitHeight = this.$refs.inputRef.$el.getBoundingClientRect().height;
				this.messageHeight = window.innerHeight - MESSAGE_HEIGHT_OFFSET;
				this.translatedContentHeight = this.$refs.inputTranslatedRef.$el.getBoundingClientRect().height + "px";
			});
		},

		// 更新对话数据
		async handleConversations() {
			try {
				const { data: conversations } = await getConversations();
				this.conversations = conversations;
				this.conversation = _.find(this.conversations, { id: this.conversation.id });
				this.$refs.detailContactRef.botsCount = this.conversation.bots.length === 0 ? {} : _.find(this.conversation.bots, { name: "METIS" });
			} catch (error) {
				this.$message.error(error);
			}
		},

		// 发送按钮点击事件
		async handleSend() {
			let preMessage;
			if (this.languageValue) {
				preMessage = generatePreMessage(this.$store.state.user, this.conversation, 0, this.translatedContent);
			} else {
				preMessage = generatePreMessage(this.$store.state.user, this.conversation, 0, this.content);
			}

			this.messages.unshift(preMessage);

			this.content = "";
			this.translatedContent = "";

			this.$nextTick().then(() => {
				this.messageHeight = window.innerHeight - MESSAGE_HEIGHT_OFFSET;
				if (this.languageValue) {
					this.contentInitHeight = this.$refs.inputTranslatedRef.$el.getBoundingClientRect().height;
				} else {
					this.contentInitHeight = this.$refs.inputRef.$el.getBoundingClientRect().height;
				}

				const newHeight = this.$refs.inputTranslatedRef.$el.getBoundingClientRect().height;
				this.translatedContentHeight = newHeight + "px";
			});

			try {
				const { data: message } = await sendMessageRequest(this.conversation, preMessage);
				this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 1, id: message.id }, "_id");
				this.conversation.last_message_timestamp = preMessage.timestamp;
			} catch (error) {
				this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 2 }, "_id");
			}
		},

		// 聊天输入框resize事件
		handleTextareaInput() {
			this.$nextTick().then(() => {
				const newHeight = this.$refs.inputRef.$el.getBoundingClientRect().height;
				if (this.contentInitHeight !== newHeight) {
					if (this.contentInitHeight > newHeight) {
						this.messageHeight = this.messageHeight + (this.contentInitHeight - newHeight);
						this.contentInitHeight = newHeight;
					} else {
						this.messageHeight = this.messageHeight - (newHeight - this.contentInitHeight);
						this.contentInitHeight = newHeight;
					}
				}
			});
		},

		// 翻译输入框内容
		handleTranslatedContent: debounce(async function () {
			if (!this.content) {
				this.translatedContent = "";
				return;
			}
			const { data } = await postTranslatedMessage(null, this.content, this.languageValue);
			this.translatedContent = data.translated_text;
		}, 500),

		handleChangeTranslatedContent() {
			this.$nextTick().then(() => {
				const newHeight = this.$refs.inputTranslatedRef.$el.getBoundingClientRect().height;
				this.translatedContentHeight = newHeight + "px";
				if (this.contentInitHeight !== newHeight) {
					if (this.contentInitHeight > newHeight) {
						this.messageHeight = this.messageHeight + (this.contentInitHeight - newHeight);
						this.contentInitHeight = newHeight;
					} else {
						this.messageHeight = this.messageHeight - (newHeight - this.contentInitHeight);
						this.contentInitHeight = newHeight;
					}
				}
			});
		},

		// 选择翻译语言事件
		handleSelectLanguage() {
			this.$nextTick().then(() => {
				const newHeight = this.$refs.inputTranslatedRef.$el.getBoundingClientRect().height;
				this.translatedContentHeight = newHeight + "px";
			});
			if (this.languageValue && this.content) {
				this.handleTranslatedContent();
			} else {
				this.translatedContent = "";
			}
		},
		// 新增: 清理已成功上传的消息
		cleanSuccessfulUploads(uploadingMessages, serverMessages) {
			// 收集服务器消息的 id
			const serverMessageIds = new Set(serverMessages.map((msg) => msg.id).filter(Boolean));

			// 过滤并清理
			return uploadingMessages.filter((msg) => {
				// 没有 id 的消息保留
				if (!msg.id) return true;

				// 服务器已有的消息,从 store 中删除
				if (serverMessageIds.has(msg.id)) {
					this.$store.commit("uploadingMessages/REMOVE_MESSAGE", msg._id);
					return false;
				}

				// 服务器没有的消息保留
				return true;
			});
		},
		// 同步消息
		async syncMessages() {
			try {
				let serverMessages = [];

				if (this.conversation.object_type === "personal") {
					const { data: messages } = await getMessages(this.conversation.object_id, null, 1);
					serverMessages = messages;
				} else {
					const { data: messages } = await getMessages(null, this.conversation.object_id, 1);
					serverMessages = messages;
				}

				// 从 store 获取当前对话的上传中消息
				const uploadingMsgsForCurrentConv = this.$store.getters["uploadingMessages/getMessagesByConversation"](this.conversation.object_id);

				const validUploadingMsgs = this.cleanSuccessfulUploads(uploadingMsgsForCurrentConv, serverMessages);

				// 合并: 本地消息 + 服务器消息
				this.messages = [...validUploadingMsgs, ...serverMessages];
			} catch (error) {
				this.messages = [];
			}
		},
		// 获取推广列表
		async syncGeneralizations(searchKeyword) {
			try {
				if (this.conversation.object_type === "personal") {
					const { data: generalizations } = await getGeneralizations(this.conversation.object_id, searchKeyword);
					this.generalizations = generalizations.map((item) => {
						item.rmsPromotion.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

						return item;
					});
				}
			} catch (error) {
				this.generalizations = [];
			}
		},
		// 表情选择
		handleEmojiSelect(emoji) {
			this.content = this.content ? this.content + emoji.native : emoji.native;
		},

		// 粘贴器的事件调用
		handleOnPaste(e) {
			this.$refs.picturePasterRef.paster(e);
		},

		// 输入框焦点
		handleTextareaFocus() {
			// TODO ..
		},

		// 用户详情点击
		handleContactDetailClick() {
			this.$refs.detailContactRef.open();
		},

		// 群组详情点击
		handleGroupDetailClick() {
			this.$refs.detailGroupRef.open();
		},

		// 更新群聊成员备注名
		handleUpdateGroupMemberNote(memberId, note) {
			_.forEach(_.filter(this.messages, { sender_id: memberId }), (item) => {
				item.sender_note = note;
			});
		},

		// 创建群组点击
		handleCreateGroupClick() {
			// TODO ..
		},

		// 通讯录点击
		handleContactsClick(contact) {
			if (contact.id) {
				const conversation = _.find(this.conversations, { object_id: contact.id });
				if (conversation) {
					this.$refs.conversationList.setCurrentRow(conversation);
					this.conversation = conversation;
				} else {
					const newConversation = {
						id: uuidv4(),
						user_id: this.$store.state.user.id,
						object_id: contact.id,
						object_type: "personal",
						object_name: contact.nick_name,
						object_avatar: contact.avatar_url || null,
						unread_count: 0,
						last_read_time: null,
						note: contact.note ? contact.note.note : null,
						customers: null,
						last_message_id: null,
						last_message_timestamp: null,
						last_message_type: null,
						last_message_text: null,
						last_message_is_delete: null,
					};
					this.conversations.push(newConversation);
					this.$refs.conversationList.setCurrentRow(newConversation);
					this.conversation = newConversation;
				}
			}
		},

		// 群聊列表点击
		handleGroupsRowClick(group) {
			const conversation = _.find(this.conversations, { object_id: group.id });
			if (conversation) {
				this.$refs.conversationList.setCurrentRow(conversation);
				this.conversation = conversation;
			} else {
				const newConversation = {
					id: uuidv4(),
					user_id: this.$store.state.user.id,
					object_id: group.id,
					object_type: "group",
					object_name: group.name,
					object_avatar: null,
					unread_count: 0,
					last_read_time: null,
					note: null,
					customers: null,
					last_message_id: null,
					last_message_timestamp: null,
					last_message_type: null,
					last_message_text: null,
					last_message_is_delete: null,
				};
				this.conversations.push(newConversation);
				this.$refs.conversationList.setCurrentRow(newConversation);
				this.conversation = newConversation;
			}
		},

		handleUploadError(error) {
			this.$message({
				message: this.$t("chat.imageUploadFailed"),
				type: "error",
			});
		},

		// 图片上传前处理
		handleUploadBefore(file) {
			// TODO: 图片压缩
		},
		// 批量文件校验
		async handleBatchMediaUploadBefore(files) {
			const validFiles = [];
			const invalidFiles = [];

			const results = await Promise.all(
				files.map(async (file) => {
					const fileName = file.name;
					let isValid = false;

					if (isImageFile(file)) {
						isValid = this.handleImageUploadBefore(file);
					} else if (isVideoFile(file)) {
						const result = await this.handleVideoUploadBefore(file);
						isValid = result.valid;
						file.duration = result.duration;
					} else {
						isValid = false;
					}

					return {
						file,
						fileName,
						isValid,
					};
				})
			);

			results.forEach(({ file, fileName, isValid }) => {
				if (isValid) {
					validFiles.push(file);
				} else {
					invalidFiles.push({ fileName });
				}
			});

			return { validFiles, invalidFiles };
		},
		// 显示文件错误提示
		showFileErrorMessage(invalidFiles) {
			if (invalidFiles.length === 0) return;

			const fileNames = invalidFiles.map((item) => item.fileName);

			let message;
			if (fileNames.length <= 3) {
				// 文件数量少时，显示具体文件名
				message = `${fileNames.join("、")} ${this.$t("chat.fileErrorTip")}`;
			} else {
				// 文件数量多时，显示前几个和总数
				message = `${fileNames.slice(0, 2).join("、")}...${fileNames.length}${this.$t("chat.aFile")}${this.$t("chat.fileErrorTip")}`;
			}

			this.$message.error(message);
		},
		triggerFileSelect() {
			this.$refs.fileInput.click();
		},

		// 原生文件选择处理 一次性获取所有文件
		async handleNativeFileChange(event) {
			const files = Array.from(event.target.files);

			if (files.length === 0) return;

			await this.processBatchFiles(files);

			event.target.value = "";
		},

		// 批量处理文件（原生文件对象）
		async processBatchFiles(files) {
			if (!files || files.length === 0) return;

			// 批量校验
			const { validFiles, invalidFiles } = await this.handleBatchMediaUploadBefore(files);

			// 显示错误提示
			if (invalidFiles.length > 0) {
				this.showFileErrorMessage(invalidFiles);
			}

			// 上传有效文件
			if (validFiles.length > 0) {
				validFiles.forEach((file) => {
					const option = { file: file };
					this.handleMediaUpload(option);
				});

				// 保存最后打开路径
				const lastFile = files[files.length - 1];
				const lastPath = lastFile.webkitRelativePath || lastFile.name;
				if (lastPath) {
					saveLastOpenPath(lastPath);
				}
			}
		},
		// 统一的媒体文件上传前验证
		handleMediaUploadBefore(file) {
			if (isImageFile(file)) {
				// 图片验证逻辑
				return this.handleImageUploadBefore(file);
			} else {
				// 视频验证逻辑
				return this.handleVideoUploadBefore(file);
			}
		},

		// 统一的媒体文件上传处理
		async handleMediaUpload(option) {
			const file = option.file;

			try {
				if (isImageFile(file)) {
					await this.handlePictureUpload(option);
				} else if (isVideoFile(file)) {
					await this.handleVideoUpload(option);
				}
			} catch (error) {
				this.handleUploadError(error);
			}
		},

		// 统一处理媒体上传和消息发送
		async sendMediaMessage({ fileType, contentType, type, file, extraData = {} }) {
			const currentConversation = this.conversation;
			const currentConversationId = currentConversation && currentConversation.id;
			const currentObjectId = currentConversation && currentConversation.object_id;
			const user = this.$store.state.user;

			let preMessage;
			let fileUploadedToOSS = false;

			try {
				// 1. 获取签名URL
				const {
					data: { filename, sign_url },
				} = await getSignature(fileType);

				// 2. 生成预消息
				preMessage = generatePreMessage(user, currentConversation, type, null, filename, extraData.duration || null);
				preMessage._conversationObjectId = currentObjectId;
				preMessage._fileUploaded = false;

				// OSS 私有化后签名地址需等服务端返回，发送中用本地 blob 地址做预览，
				// 发送成功后被服务端返回的签名 attachment_url 覆盖
				preMessage.attachment_url = URL.createObjectURL(file);
				const previewUrl = preMessage.attachment_url;

				//3. 将消息添加到 Vuex store
				this.$store.commit("uploadingMessages/ADD_MESSAGE", {
					id: preMessage._id,
					message: preMessage,
					conversationObjectId: currentObjectId,
					fileUploaded: false,
				});

				// 4. UI显示预发送消息
				const isCurrentConversation = this.conversation && this.conversation.id === currentConversationId;
				if (isCurrentConversation) {
					this.messages.unshift(preMessage);
				}

				// 5. 上传文件
				if (fileType === Media_File_Type.VIDEO) {
					await uploadVideo(sign_url, file, contentType);
				} else {
					await upload(sign_url, file, contentType);
				}

				fileUploadedToOSS = true;
				this.$store.commit("uploadingMessages/MARK_FILE_UPLOADED", preMessage._id);

				// 6. 发送消息请求
				const { data: message } = await sendMessageRequest(currentConversation, preMessage);

				// 7. 从 store 中移除
				this.$store.commit("uploadingMessages/REMOVE_MESSAGE", preMessage._id);

				// 8. 更新消息状态
				if (this.conversation && this.conversation.object_id === currentObjectId) {
					const existingMsg = this.messages.find((msg) => msg._id === preMessage._id);

					if (existingMsg) {
						this.messages = updateArray(
							this.messages,
							{
								...message,
								_id: preMessage._id,
								_status: 1,
								id: message.id,
							},
							"_id"
						);
					} else {
						// 消息不存在,可能被 syncMessages 清除,重新插入
						this.messages.unshift({
							...message,
							_status: 1,
						});
					}
				}

				// 发送成功后本地 blob 预览不再需要（展示走服务端签名地址），回收释放内存
				if (previewUrl) {
					this.$nextTick(() => URL.revokeObjectURL(previewUrl));
				}

				// 9. 更新会话
				if (currentConversation) {
					currentConversation.last_message_timestamp = preMessage.timestamp;
				}
			} catch (error) {
				// 更新失败状态
				if (preMessage) {
					// 更新 store 中的状态
					this.$store.commit("uploadingMessages/UPDATE_MESSAGE_STATUS", {
						id: preMessage._id,
						status: 2,
					});

					if (this.conversation && this.conversation.object_id === currentObjectId) {
						const existingMsg = this.messages.find((msg) => msg._id === preMessage._id);

						if (existingMsg) {
							this.messages = updateArray(
								this.messages,
								{
									_id: preMessage._id,
									_status: 2,
								},
								"_id"
							);
						} else {
							this.messages.unshift({
								...preMessage,
								_status: 2,
							});
						}
					}

					// 文件未上传到 OSS,删除失败消息
					if (!fileUploadedToOSS) {
						this.$store.commit("uploadingMessages/REMOVE_MESSAGE", preMessage._id);
					}
				}
			}
		},

		// 图片上传前验证
		handleImageUploadBefore(file) {
			return true;
		},

		// 视频上传前验证
		handleVideoUploadBefore(file) {
			const allowedTypes = ["mp4"];
			const fileExtension = file.name.split(".").pop().toLowerCase();

			if (!allowedTypes.includes(fileExtension)) {
				return false;
			}

			const maxSize = 300 * 1024 * 1024; // 300M
			if (file.size > maxSize) {
				return false;
			}

			// 检查时长
			return new Promise((resolve) => {
				const video = document.createElement("video");
				video.preload = "metadata";

				video.onloadedmetadata = () => {
					window.URL.revokeObjectURL(video.src);
					const duration = Math.floor(video.duration);
					const maxDuration = 30 * 60;
					if (duration > maxDuration) {
						resolve({ valid: false, duration });
					} else {
						resolve({ valid: true, duration });
					}
				};

				video.onerror = () => {
					window.URL.revokeObjectURL(video.src);
					resolve(false);
				};

				video.src = URL.createObjectURL(file);
			});
		},

		// 视频上传处理方法
		async handleVideoUpload(option) {
			await this.sendMediaMessage({
				...Media_File_Type_Config.video,
				file: option.file,
				extraData: {
					duration: option.file.duration,
				},
			});
		},

		// 图片上传请求
		async handlePictureUpload(option) {
			await this.sendMediaMessage({
				...Media_File_Type_Config.image,
				file: option.file,
			});
		},

		// 录音完成
		async handleRecorderDone(event) {
			await this.sendMediaMessage({
				...Media_File_Type_Config.voice,
				file: event.file,
				extraData: { duration: event.duration },
			});
		},

		// 图片粘贴
		async handlePicturePasterUpload(file) {
			await this.sendMediaMessage({
				...Media_File_Type_Config.image,
				file,
			});
		},
		// 群聊点击
		handleHistoryClick() {
			this.$refs.chatHistoryRef.show();
		},

		// 消息撤回
		async handleRecallMessage(message) {
			if (!message.is_sender) {
				this.$message.error(this.$t("chat.onlyWithdrawMessages"));
				return;
			}

			try {
				await recallMessage(message.id);

				this.messages = updateArray(this.messages, { id: message.id, is_delete: true }, "id");
			} catch (error) {
				this.$message.error(error);
			}
		},

		// 消息重发
		async handleResendMessage(preMessage) {
			try {
				const isMediaMessage = [MESSAGE_TYPE.Image, MESSAGE_TYPE.Video].includes(preMessage.type);
				if (isMediaMessage) {
					// 检查文件是否已上传到 OSS
					if (!preMessage._fileUploaded) {
						this.$message.warning(this.$t("chat.errorTip"));

						this.$store.commit("uploadingMessages/REMOVE_MESSAGE", preMessage._id);
						this.messages = this.messages.filter((msg) => msg._id !== preMessage._id);
						return;
					}

					const tempTimestamp = getCurrentUtcDatetime();

					// 更新为发送中状态
					this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 0, timestamp: tempTimestamp }, "_id");

					try {
						const { data: message } = await sendMessageRequest(this.conversation, preMessage);

						// 成功
						this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 1, id: message.id }, "_id");

						this.conversation.last_message_timestamp = tempTimestamp;

						// 从 store 中移除
						this.$store.commit("uploadingMessages/REMOVE_MESSAGE", preMessage._id);
					} catch (error) {
						console.error("重新发送失败:", error);

						// 失败
						this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 2 }, "_id");

						this.$store.commit("uploadingMessages/UPDATE_MESSAGE_STATUS", {
							id: preMessage._id,
							status: 2,
						});
					}

					return;
				}

				const tempTimestamp = getCurrentUtcDatetime();
				this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 0, timestamp: tempTimestamp }, "_id");

				const { data: message } =
					preMessage.type === MESSAGE_TYPE.Markdown
						? await sendGeneralizationMessageRequest({
								contact_id: preMessage.receive_id,
								id: preMessage.rmsPromotion_id,
								type: MESSAGE_TYPE.Markdown,
								markdown: preMessage.markdown,
								execution_details_id: preMessage.execution_details_id,
						  })
						: await sendMessageRequest(this.conversation, preMessage);

				if (preMessage.type === MESSAGE_TYPE.Markdown) {
					this.generalizations = this.generalizations.map((item) => {
						if (preMessage.customerId === item.customerId) {
							return {
								...item,
								rmsPromotion: item.rmsPromotion.map((message) => {
									if (preMessage.execution_details_id === message.execution_details_id) {
										return { ...message, is_send: true };
									}
									return message;
								}),
							};
						}
						return item;
					});
				}
				this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 1, id: message.id }, "_id");
				this.conversation.last_message_timestamp = tempTimestamp;
			} catch (error) {
				this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 2 }, "_id");
			}
		},

		// 消息接受事件处理
		handleOnMessageReceived(message) {
			browserNotification(message);

			if (this.conversation) {
				if (this.conversation.user_id === message.receive_id && this.conversation.object_id === message.sender_id) {
					if (this.conversation.auto_translate === 1) {
						try {
							postTranslatedMessage(message.id, message.text, "zh-TW").then((result) => {
								message.translated_text = result.data.translated_text;
								let receiveMessage;
								if (message.sender_id === message.original_sender_id) {
									receiveMessage = _.assign({}, message, { is_sender: false, is_read: false });
								} else {
									receiveMessage = _.assign({}, message, { is_sender: true, is_read: false });
								}
								this.messages = updateOrCreate(this.messages, receiveMessage, "id");
							});
						} catch (error) {
							this.$message({ message: error, type: "error" });
						}
					}
				}
			}

			let objectId;
			if (message.group_id) {
				objectId = message.group_id;
			} else {
				objectId = message.sender_id === message.original_sender_id ? message.sender_id : message.receive_id;
			}

			const oldConversation = _.find(this.conversations, { object_id: objectId });

			const conversation = {
				id: oldConversation ? oldConversation.id : uuidv4(),
				user_id: this.$store.state.user.id,
				object_id: objectId,
				object_type: message.group_id ? "group" : "personal",
				object_name: message.group_id ? message.group_name : message.sender_name,
				object_avatar: message.group_id ? "" : message.sender_avatar,
				unread_count: oldConversation ? oldConversation.unread_count + 1 : 1,
				last_read_time: oldConversation ? oldConversation.last_read_time : null,
				note: oldConversation ? oldConversation.note : null,
				customers: oldConversation ? oldConversation.customers : null,
				last_message_id: message.id,
				last_message_timestamp: message.timestamp,
				last_message_type: message.type,
				last_message_text: message.text,
				last_message_is_delete: message.is_delete,
			};

			this.conversations = updateOrCreate(this.conversations, conversation, "object_id");

			if (this.conversation && this.conversation.object_id === objectId) {
				let receiveMessage;
				if (message.sender_id === message.original_sender_id) {
					receiveMessage = _.assign({}, message, { is_sender: false, is_read: false });
				} else {
					receiveMessage = _.assign({}, message, { is_sender: true, is_read: false });
				}
				this.messages = updateOrCreate(this.messages, receiveMessage, "id");
				this.conversations = updateOrCreate(this.conversations, { object_id: objectId, unread_count: 0 }, "object_id");
			}

			this.$store.commit("SET_TOTAL_UNREAD", this.unreadCountTotal);

			// TODO：需要节流优化
			resetUnreadCountAndReportReadTime(this.conversation.object_id);
		},

		// 消息撤回事件处理
		handleOnMessageRecalled(message) {
			const objectId = message.group_id ? message.group_id : message.sender_id;

			if (this.conversation && this.conversation.object_id === objectId) {
				const receiveMessage = _.assign({}, message, { is_sender: false, is_read: false });
				this.messages = updateOrCreate(this.messages, receiveMessage, "id");
			}
		},

		// 对话更新事件处理
		handleOnConversationUpdated(conversation) {
			this.conversations = updateOrCreate(this.conversations, conversation, "object_id");
		},

		// 联系人更新事件处理
		handleOnContactsUpdated() {
			// TODO ..
		},
		//主动请求数据
		async syncConversations() {
			const { data: conversations } = await getConversations();
			this.conversations = conversations;
		},
		//webSocket断开，连接处理
		handleWebSocketState(mutationType) {
			switch (mutationType) {
				case "SOCKET_ONOPEN":
					if (this.timer != null) {
						clearInterval(this.timer);
						this.timer = null;
						this.syncConversations();
						this.$store.dispatch("getTotalUnread");
						this.syncMessages();
					}
					break;
				case "SOCKET_ONCLOSE":
					if (this.timer == null) {
						this.timer = setInterval(() => {
							this.syncConversations();
							this.$store.dispatch("getTotalUnread");
							this.syncMessages();
						}, 10000);
					}
					break;
			}
		},

		//v-viewer查看图片事件
		handleImageView(message) {
			this.$refs.chatImageViewer.imageViewer(message, this.conversation.object_id);
			this.$refs.chatImageViewer.showViewer();
		},
		//查看视频事件
		handleVideoViewer(message) {
			this.$refs.chatVideoViewer.videoViewer(message, this.conversation.object_id);
			this.$refs.chatVideoViewer.showViewer();
		},

		//对话框搜索获取焦点
		onFocus() {
			this.isSearchFocused = true;
		},
		// 推广列表发送成功后的处理
		async handleSendGeneralization(sendMessage) {
			const entireContent = sendMessage.title + "  \n" + sendMessage.content;
			const preMessage = generatePreMessage(this.$store.state.user, this.conversation, MESSAGE_TYPE.Markdown, null, null, null, entireContent);

			this.messages.unshift({ ...preMessage, rmsPromotion_id: sendMessage.id, execution_details_id: sendMessage.execution_details_id });

			this.sendDialogVisible = false;
			try {
				const { data: message } = await sendGeneralizationMessageRequest({
					contact_id: preMessage.receive_id,
					id: sendMessage.id,
					type: MESSAGE_TYPE.Markdown,
					markdown: entireContent,
					execution_details_id: sendMessage.execution_details_id,
				});
				this.generalizationDetailDialogVisible = false;
				this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 1, id: message.id }, "_id");
				this.generalizations = this.generalizations.map((item) => {
					if (sendMessage.customerId === item.customerId) {
						return {
							...item,
							rmsPromotion: item.rmsPromotion.map((message) => {
								if (sendMessage.id === message.id) {
									return { ...message, is_send: true };
								}

								return message;
							}),
						};
					}
					return item;
				});
			} catch (error) {
				this.messages = updateArray(this.messages, { _id: preMessage._id, _status: 2 }, "_id");
			}
			this.conversation.last_message_timestamp = preMessage.timestamp;
		},
		handleOpenSendDialog(sendMessage) {
			if (sendMessage) {
				this.sendDialogVisible = true;
				this.readyToSendGeneralization = sendMessage;
			}
		},
		handleCloseSendDialog() {
			this.sendDialogVisible = false;
		},
		startResize(e) {
			this.isResizing = true;
			this.startX = e.clientX;
			this.startWidth = this.leftWidth;

			document.addEventListener("mousemove", this.handleResize);
			document.addEventListener("mouseup", this.stopResize);
			document.body.style.cursor = "ew-resize";
			document.body.style.userSelect = "none";
		},
		handleResize(e) {
			if (!this.isResizing) return;

			const diff = e.clientX - this.startX;
			let newWidth = this.startWidth + diff;

			// 限制宽度范围
			newWidth = Math.max(this.minWidth, Math.min(this.maxWidth, newWidth));

			this.leftWidth = newWidth;
		},
		stopResize() {
			this.isResizing = false;
			document.removeEventListener("mousemove", this.handleResize);
			document.removeEventListener("mouseup", this.stopResize);
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
		},
		/**
		 * 显示发送配置弹窗
		 */
		showSendConfigDialog() {
			this.sendConfigPopoverVisible = true;
		},

		/**
		 * 保存发送配置
		 */
		saveSendConfig() {
			try {
				localStorage.setItem("chatSendMethodConfig", this.sendMethodConfig);

				this.$message.success(this.$t("customerPhone.setupSuccessful"));
				this.sendConfigPopoverVisible = false;
			} catch (error) {
				console.error(error);
			}
		},

		/**
		 * 加载发送配置
		 */
		loadSendConfig() {
			try {
				const savedConfig = localStorage.getItem("chatSendMethodConfig");
				if (savedConfig) {
					this.sendMethodConfig = savedConfig;
				}
			} catch (error) {
				console.error(error);
			}
		},

		/**
		 * 处理键盘发送
		 * @param {String} key - 按下的键: 'ctrl' 或 'enter'
		 * @param {Event} event - 键盘事件
		 */
		handleKeyboardSend(key, event) {
			// 如果配置是 Ctrl+Enter 发送
			if (this.sendMethodConfig === Send_Method_TYPE.CtrlEnter) {
				if (key === Send_Method_TYPE.CtrlEnter) {
					// 在 macOS 上，只有 Cmd+Enter 才发送消息
					// 在 Windows/Linux 上，Ctrl+Enter 发送消息
					if ((this.isMac && event.metaKey) || (!this.isMac && event.ctrlKey)) {
						event.preventDefault();
						this.handleSend();
					} else if (this.isMac && event.ctrlKey) {
						// macOS 上的 Ctrl+Enter 用于换行
						event.preventDefault();
						const textarea = event.target;
						const start = textarea.selectionStart;
						const end = textarea.selectionEnd;
						const value = textarea.value;
						this.content = value.substring(0, start) + "\n" + value.substring(end);
						this.$nextTick(() => {
							textarea.selectionStart = textarea.selectionEnd = start + 1;
						});
					}
				}
				// Enter 单独按下时保持默认行为（换行）
			} else if (this.sendMethodConfig === Send_Method_TYPE.Enter) {
				if (key === Send_Method_TYPE.Enter && !event.ctrlKey && !event.metaKey) {
					// 单独按 Enter 发送消息
					event.preventDefault();
					this.handleSend();
				}
				// Ctrl+Enter 或 Command+Enter 用于换行
				else if (key === Send_Method_TYPE.CtrlEnter) {
					event.preventDefault();
					// 在光标位置插入换行符
					const textarea = event.target;
					const start = textarea.selectionStart;
					const end = textarea.selectionEnd;
					const value = textarea.value;
					this.content = value.substring(0, start) + "\n" + value.substring(end);
					// 设置光标位置
					this.$nextTick(() => {
						textarea.selectionStart = textarea.selectionEnd = start + 1;
					});
				}
			}
		},

		/**
		 * 获取发送方式的占位符文本
		 */
		getSendMethodPlaceholder() {
			if (this.sendMethodConfig === Send_Method_TYPE.CtrlEnter) {
				return this.isMac ? this.$t("chat.commandEnter") : this.$t("chat.ctrlEnter");
			} else {
				return this.$t("chat.enter");
			}
		},
	},

	watch: {
		conversation: async function (newValue, oldValue) {
			// 清空输入框内容
			this.content = null;

			this.loading = true;

			if (newValue) {
				resetUnreadCountAndReportReadTime(newValue.object_id);

				this.conversations = updateArray(this.conversations, { object_id: newValue.object_id, unread_count: 0 }, "object_id");
			}

			this.$store.commit("SET_TOTAL_UNREAD", this.unreadCountTotal);

			await this.syncMessages();
			await this.syncGeneralizations();
			this.contentInitHeight = this.$refs.inputRef.$el.getBoundingClientRect().height;

			this.loading = false;
		},

		windowHeight: function (newValue, oldValue) {
			if (newValue) {
				this.tabHeight = newValue - TAB_HEIGHT_OFFSET;

				// 输入框对比之前高出部分
				const superfluousHeight = this.$refs.inputRef.$el.getBoundingClientRect().height - 75;

				this.messageHeight = newValue - MESSAGE_HEIGHT_OFFSET - superfluousHeight;
			}
		},
	},
	computed: {
		unreadCountTotal: function () {
			return _.sumBy(this.conversations, "unread_count");
		},

		// 判断是否为 macOS 系统
		isMac: function () {
			return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
		},

		// 最近聊天筛选
		conversationListData: function () {
			if (this.searchKeyword) {
				return this.conversations.filter((item) => {
					return (
						(item.note && item.note.toLowerCase().includes(this.searchKeyword.toLowerCase())) ||
						item.object_name.toLowerCase().includes(this.searchKeyword.toLowerCase())
					);
				});
			}
		},

		// 群聊筛选
		groupsData: function () {
			if (this.searchKeyword) {
				return this.groups.filter((item) => {
					return item.name.toLowerCase().includes(this.searchKeyword.toLowerCase());
				});
			}
		},

		// 联系人筛选
		contactsData: function () {
			if (this.searchKeyword) {
				let contactsData = [];
				this.contacts.map((item) => {
					item.users.map((_item) => {
						if (_item.nick_name.toLowerCase().includes(this.searchKeyword.toLowerCase())) {
							if (!contactsData.find((element) => element.id === _item.id)) {
								contactsData.push(_item);
							}
						}
					});
				});
				return contactsData;
			}
		},
	},
};

export const GENERALIZATION_HEIGHT_OFFSET = 282;
